import { render, staticRenderFns } from "./GreenCheck.vue?vue&type=template&id=48457bed"
import script from "./GreenCheck.vue?vue&type=script&lang=js"
export * from "./GreenCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports